import { InroomAdminMutation } from "@/framework/store/inroom_admin/types";
import { EarliestInquiryInfo } from "@/framework/network/gql/generated/graphql";

export default {
  [InroomAdminMutation.SET_SANDBOX_LOGOUT_MEMO](state: any, payload: string) {
    state.sandboxLogoutMemo = payload;
  },
  [InroomAdminMutation.SET_IS_IMPORT_IN_PROGRESS](state: any, payload: boolean) {
    state.isImportInProgress = payload;
  },
  [InroomAdminMutation.SET_IS_USER_IMPORTING_TO_DICTIONARY](state: any, payload: boolean) {
    state.isUserImportingToDictionary = payload;
  },
  [InroomAdminMutation.SET_INQUIRY_INFO](state: any, payload: EarliestInquiryInfo) {
    state.inquiryInfo = payload;
  },
};
